import { useState, useEffect } from "react";
import { useSession } from "context/SessionContext";
import { subDays } from "date-fns";
import { convertDateTimeISOWithTimeZoneEND } from "utils";
import api from "services/api";
import moment from 'moment';

export default function useCorreios(correiosId?: string) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const today = moment().add(3, 'hours').toDate()

  const [reqBody, setReqBody] = useState({
    DTINI: convertDateTimeISOWithTimeZoneEND(subDays(today, 3)),
    DTFIM: convertDateTimeISOWithTimeZoneEND(today),
  });

  const [recentEvents, setRecentEvents] = useState([]);
  const { IDMCM } = useSession();
  const [eventsLength, setEventsLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  const getEvents = async (page?: number) => {
    setLoading(true);

    try {

      if(page) {
        setCurrentPage(page);      
      }

      const resp = await api.patch(
        `/api_front/MCMEventosCorreios/${IDMCM}/${((page?page:currentPage)-1)*pageSize}/${pageSize}`,
        reqBody
      );
      setRecentEvents(resp?.data);
    } catch (err) {
      console.log("Requisição de eventos falhou. Page:", page);
      setRecentEvents([]);
    } finally {
      setLoading(false);
    }
  };

  const getQtyEvents = async (page?:number) => {

    setLoading(true);

    if(page)
      setCurrentPage(page);

    setRecentEvents([]);
    try {

      const resp = await api.patch(
        `/api_front/MCMEventosCorreios/${IDMCM}`,
        reqBody
      );
      setEventsLength(resp?.data.QTD);

      getEvents(page);

    } catch (err) {

      console.log("requisição de quantidade de eventos falhou");

    } finally {

      setLoading(false);

    }
  };

  const getEventsLength = async(start:Date,end:Date) => {

    try {

      setLoading(true);
      const res = await api.patch(
        `/api_front/MCMEventosCorreios/${IDMCM}`,
        
      );

      setLoading(false);
      return res?.data.QTD;

    } catch(err){
      console.log(err);
      setLoading(false);
    }
  }

  useEffect(() => {
    // PEGA A PARTIR DE TRÊS DIAS ATRÁS DA DATA ATUAL
    getQtyEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [IDMCM, reqBody]);

  const eventsOptions = [
    {
      label: "LOGIN DE USUÁRIO",
      value: 500,
    },
    {
      label: "ENCERRAMENTO DE SESSÃO - LOGOFF",
      value: 501,
    },
    {
      label: "ALTERAÇÃO DO RELÓGIO",
      value: 502,
    },
    {
      label: "BLOQUEIO DE COMPARTIMENTOS DANIFICADOS",
      value: 503,
    },
    {
      label: "DESBLOQUEIO DE COMPARTIMENTOS ANTERIORMENTE BLOQUEADOS",
      value: 504,
    },
    {
      label: "INDISPONIBILIDADE TOTAL DE COMPARTIMENTOS PARA DISTRIBUIÇÃO",
      value: 505,
    },
    {
      label: "TAMANHO DE COMPARTIMENTO SELECIONADO INDISPONÍVEL",
      value: 506,
    },
    {
      label: "RETIRADA DA ENCOMENDA",
      value: 507,
    },
    {
      label: "ENTREGA DA ENCOMENDA",
      value: 508,
    },
    {
      label: "EQUIPAMENTO DISPONÍVEL",
      value: 509,
    },
  ];

  async function setPagination(OFFSET: number, LIMIT: number) {
    // try {
    //   setLoading(true);
    //   const { data } = await orderService.getAll({ OFFSET: OFFSET > 0 ? OFFSET : 0, LIMIT: 1000 });
    //   setAddreesses(data);
    // } catch (error) {
    //   } finally {
    //     setLoading(false);
    //   }
  }

  async function getEventsByFilters(num: number) {
    setLoading(true);
    console.log('events',recentEvents);
    const filteredEvents = recentEvents.filter((item: any) => item?.CDNOTIF === num);
    if (filteredEvents) {
      setLoading(false);
      return setRecentEvents(filteredEvents);
    } else {
      setLoading(false);
      return setRecentEvents([]);
    }
  }

  return {
    loading,
    setLoading,
    setPagination,
    eventsOptions,
    getEventsByFilters,
    error,
    setError,
    IDMCM,
    recentEvents,
    setReqBody,
    getQtyEvents,
    getEventsLength,
    eventsLength,
    setCurrentPage,
    currentPage,
  };
}
